import { render, staticRenderFns } from "./createAffiliateFields.vue?vue&type=template&id=4bafa94d&"
import script from "./createAffiliateFields.vue?vue&type=script&lang=ts&"
export * from "./createAffiliateFields.vue?vue&type=script&lang=ts&"
import style0 from "./createAffiliateFields.vue?vue&type=style&index=0&id=4bafa94d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports